module.exports = "/_next/static/media/onboard-3-import.a168d548.mp4";